import React /* ,{ Component } */ from 'react';
import PropTypes from 'prop-types';
import {
  DataGridCustom,
  Grid,
  Input,
} from '../../components';

// class SelecaoSuperintendencia extends Component {
const SelecaoSuperintendencia = (props) => {
  let selecaoSuperintendencia;
  let selecaoGex;
  if (!props.tipoRegime && ['analista-rgps', 'analista-dtp', 'analista-sprev', 'analista-dcomp'].includes(props.papelUsuarioLogado)) {
    selecaoSuperintendencia = (
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            label="Superintendência"
            onChange={e => props.handleChange(e, 'superintendencia')}
            value={props.superintendencia}
            custom
            disabled={!props.papelUsuarioLogado === 'analista-rgps' && props.ehPapelObservadorRelatorio && !props.tipoRegimeObservador}
            itemList={props.listaSuperintendencias}
            required
          />
        </Grid>
        {props.superintendencia ? (
          <Grid cols="6 6 6 6">
            <Input
              label="GEX"
              onChange={e => props.handleChange(e, 'gex')}
              placeholder="Todas"
              value={props.gex}
              itemList={props.listaGexs}
              custom
            />
          </Grid>
        ) : ''}
      </div>
    );
  }
  if (props.gex && (props.papelUsuarioLogado === 'analista-rgps' || props.tipoRegimeObservador === 1)) {
    selecaoGex = (
      <div className="row">
        <Grid cols="6 6 6 6">
          <Input
            label="APS"
            onChange={e => props.handleChange(e, 'aps')}
            placeholder="Todas"
            value={props.aps}
            itemList={props.listaAps}
            custom
          />
        </Grid>
      </div>
    );
  }
  return (
    <DataGridCustom title={props.titulo} retirarLinhaSeparadora={props.retirarLinhaSeparadora}>
      { selecaoSuperintendencia }
      { selecaoGex }
    </DataGridCustom>
  );
// }
};

SelecaoSuperintendencia.propTypes = {
  listaSuperintendencias: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  listaGexs: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  listaAps: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
  }).isRequired,
  superintendencia: PropTypes.number.isRequired,
  gex: PropTypes.number.isRequired,
  aps: PropTypes.number.isRequired,
  titulo: PropTypes.string.isRequired,
  retirarLinhaSeparadora: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  tipoRegime: PropTypes.number.isRequired,
  papelUsuarioLogado: PropTypes.string.isRequired,
  tipoRegimeObservador: PropTypes.number.isRequired,
  ehPapelObservadorRelatorio: PropTypes.bool.isRequired,
};

export default SelecaoSuperintendencia;



// WEBPACK FOOTER //
// ./src/pages/relatorios/SelecaoSuperintendencia.jsx